import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { register } from './serviceWorkerRegistration'

// Registrar el service worker para habilitar las funciones PWA
register();

createRoot(document.getElementById("root")!).render(<App />);
